import ResumenTable from './ResumenTable';

export type { RankingTableProps } from './ResumenTable';

export default ResumenTable;
